import { firebase } from '../../../firebase';
import { default as config } from '../../../constants/constants';
import axios from 'axios';
import AWS from 'aws-sdk';

export const initializePollyProcess = async (
  e,
  flags,
  selectedFlags,
  callback
) => {
  if (e !== undefined) {
    e.stopPropagation();
  }
  if (firebase.auth.currentUser) {
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      const resultAmazon = await getAmazonToken(token);
      if (resultAmazon) {
        const { token1, identityPoolId, identityId } = resultAmazon;
        const region = 'us-east-1';

        AWS.config.region = region;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: identityPoolId,
          IdentityId: identityId,
          Logins: {
            'cognito-identity.amazonaws.com': token1
          }
        });

        const polly = new AWS.Polly({
          apiVersion: '2016-06-10',
          region: region,
          credentials: AWS.config.credentials
        });

        const promises = await synthesizeSpeech(flags, polly, selectedFlags);
        if (promises) {
          Promise.all(promises)
            .then((items) => {
              items.length > 0 ? callback(items) : '';
            })
            .catch((e) => console.error(e));
        }
      }
    }
  }
};

const synthesizeSpeech = async (flags, polly, selectedFlags) => {
  try {
    let params = null;
    let signer = null;

    signer = new AWS.Polly.Presigner(params, polly);
    let documents = [];
    let podcasts = [];
    let documentName = '';
    let podcastName = '';
    let promises = flags.map((item) => {
      return new Promise((resolve, reject) => {
        documentName = item.document || localStorage.getItem('documentName');
        podcastName = item.podcast || localStorage.getItem('podcastName');
        const params = {
          Engine: 'neural',
          OutputFormat: 'mp3',
          TextType: 'ssml',
          VoiceId: 'Matthew',
          Text:
            !selectedFlags || documents.includes(documentName)
              ? `<speak> <amazon:domain name="news"> ${item.text} </amazon:domain> </speak>`
              : podcasts.includes(podcastName) &&
                !documents.includes(documentName)
              ? `<speak> <amazon:domain name="news"> ${'Document: ' +
                  documentName +
                  '. Flags: ' +
                  item.text} </amazon:domain></speak>`
              : podcasts.length === 0 || !podcasts.includes(podcastName)
              ? `<speak> <amazon:domain name="news">${'Podcast: ' +
                  podcastName +
                  '. Document: ' +
                  documentName +
                  '. Flags: ' +
                  item.text} </amazon:domain></speak>`
              : ''
        };
        signer.getSynthesizeSpeechUrl(params, function(error, url) {
          if (error) {
            reject(error);
          } else {
            resolve({
              id: item.flagId,
              url,
              document: documentName,
              podcast: podcastName
            });
          }
        });
        documents.push(documentName);
        podcasts.push(podcastName);
      });
    });

    return promises;
  } catch (error) {
    console.error('Error synthesizing speech:', error);
  }
};

const getAmazonToken = async (token) => {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/auth/cognito`
  };
  const res = await axios(options);
  if (res) {
    const token1 = res.data.token;
    const identityPoolId = res.data.identityPoolId;
    const identityId = res.data.identityId;

    const result = { token1, identityPoolId, identityId };

    return result;
  }
};
